import { Stack } from '@mui/material';
import { z } from 'zod';

import { api } from 'common';

import { PatientJobParamsFormFields, PatientJobParamsSchema } from './Common/Patients';
import { type AsynchronousJobVariant, RequiredStringSchema } from './common';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

import JobKind = api.RpaJob.Kind;

export const ExportCareGapFindingsVariant: AsynchronousJobVariant = {
  schema: z.object({
    jobKind: z.literal(JobKind.ExportCareGapFindings),
    payload: PatientJobParamsSchema.extend({
      noteText: RequiredStringSchema,
    }),
  }),
  Config: () => {
    return (
      <Stack spacing={2}>
        <BlockValueTemplateField
          fieldName="config.payload.noteText"
          label="Note Text"
          helperText="Enter the reference to the note text. e.g. `{{note.data}}`"
          placeholder="e.g. {{note.data}}"
        />
        <PatientJobParamsFormFields />
      </Stack>
    );
  },
};
